/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Type of the source: reading or setting.
 */
export const SourceType = {
  Reading: "reading",
  Setting: "setting",
} as const;
/**
 * Type of the source: reading or setting.
 */
export type SourceType = ClosedEnum<typeof SourceType>;

/**
 * Kind of the reading
 */
export const QueryTrendSourceValueKind = {
  Number: "number",
  Boolean: "boolean",
  Enum: "enum",
  Schedule: "schedule",
  Sequence: "sequence",
  String: "string",
} as const;
/**
 * Kind of the reading
 */
export type QueryTrendSourceValueKind = ClosedEnum<
  typeof QueryTrendSourceValueKind
>;

/**
 * A source to query with its type and value kind for aggregation selection.
 */
export type QueryTrendSource = {
  /**
   * Universally unique identifier
   */
  id: string;
  /**
   * Type of the source: reading or setting.
   */
  sourceType: SourceType;
  /**
   * Kind of the reading
   */
  valueKind: QueryTrendSourceValueKind;
};

/** @internal */
export const SourceType$outboundSchema: z.ZodNativeEnum<typeof SourceType> = z
  .nativeEnum(SourceType);

/** @internal */
export const QueryTrendSourceValueKind$outboundSchema: z.ZodNativeEnum<
  typeof QueryTrendSourceValueKind
> = z.nativeEnum(QueryTrendSourceValueKind);

/** @internal */
export type QueryTrendSource$Outbound = {
  id: string;
  source_type: string;
  value_kind: string;
};

/** @internal */
export const QueryTrendSource$outboundSchema: z.ZodType<
  QueryTrendSource$Outbound,
  z.ZodTypeDef,
  QueryTrendSource
> = z.object({
  id: z.string(),
  sourceType: SourceType$outboundSchema,
  valueKind: QueryTrendSourceValueKind$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    sourceType: "source_type",
    valueKind: "value_kind",
  });
});

export function queryTrendSourceToJSON(
  queryTrendSource: QueryTrendSource,
): string {
  return JSON.stringify(
    QueryTrendSource$outboundSchema.parse(queryTrendSource),
  );
}
